import { tabPaths } from '../../../store/index.js';

import { OrderTypes } from '@/constants';

export const queryParamsInitial = {
  page: 1,
  pageSize: 10,
  filters: [],
  sortKey: 'id',
  sortDirection: OrderTypes.Desc,
  tab: tabPaths['monitoring-objects'],
};

export const instructionTypeForFilter = {
  filterId: 'number',
  filterProfileName: 'string',
  filterName: 'string',
  filterPartnerClientAccountId: 'number',
};
